export const coreDataEndpoints = {
  getOrgCoreDataDependenciesForType: { method: 'get', path: '/dependencies/organisation/{entityType}' },
  getDependenciesForCoreDataEntity: { method: 'post', path: '/dependencies/entity/{coreDataEntityId}' },
  getSystemCoreData: { method: 'get', path: '/system-core-data/{entityType}' },
  getSystemCoreDataWithDependencies: { method: 'get', path: '/system-core-data/{entityType}/dependencies' },
  getCustomCoreData: { method: 'get', path: '/custom' },
  queryCustomCoreData: { method: 'post', path: '/custom/query' },
  getCustomCoreDataLabels: { method: 'get', path: '/custom/labels' },
  getCustomCoreDataOptions: { method: 'get', path: '/custom/{customCoreDataId}/options' },
  insertCustomCoreData: { method: 'post', path: '/custom/insert' },
  insertSystemCoreData: { method: 'post', path: '/system' },
  updateCustomCoreData: { method: 'post', path: '/custom/{customCoreDataId}/update' },
  updateSystemCoreData: { method: 'post', path: '/system/{id}/update' },
  archiveCustomCoreData: { method: 'post', path: '/custom/{customCoreDataId}/archive' },
  unarchiveCustomCoreData: { method: 'post', path: '/custom/{customCoreDataId}/unarchive' },
  unarchiveCoreDataOptions: { method: 'post', path: '/options/unarchive' },
  archiveCoreDataOptions: { method: 'post', path: '/options/archive' },
  insertCustomCoreDataOption: { method: 'post', path: '/custom/option/insert' },
  updateCustomCoreDataOption: { method: 'post', path: '/custom/option/{customCoreDataOptionId}/update' },
  syncExternalEntity: { method: 'post', path: '/entities/{entityType}/sync/external' },
  syncAllExternalEntities: { method: 'post', path: '/entities/sync/external/all' },
  getCoreDataItemById: { method: 'post', path: '/{coreDataType}/{id}' },
  batchGetItems: { method: 'post', path: '/batch-get-items' },
  coreDataBulkUpload: { method: 'post', path: '/{coreDataType}/bulk-upload' },
  customCoreDataBulkUpload: { method: 'post', path: '/custom/{customCoreDataId}/upload' },
  multiLevelCustomCoreDataBulkUpload: { method: 'post', path: '/custom/multi-level/{customCoreDataId}/upload' },
  isOptionDescendantOf: { method: 'post', path: '/options/is-descendant-of' },
  getCustomCoreDataChildren: { method: 'post', path: '/custom/{customCoreDataId}/children' },
} as const
